import React from 'react';
import { FaTimes } from 'react-icons/fa';

const DefinitionModal = ({ onClose, definitionInfo, label }) => {
  return (
    <div className='flex font-sans_book_body cursor-default justify-center items-center z-10 fixed left-0 top-0 w-screen h-screen bg-gray-500 bg-opacity-75 transition-opacity'>
      <div className={`flex flex-col w-[95%] ${Object.entries(definitionInfo).length < 5 ? 'h-fit md:w-2/5' : 'h-3/4 md:w-[65%]'} bg-white rounded-lg`}>
        <div className="py-2 sticky flex items-center justify-between top-1 rounded-t-lg border-b">
          <p className="font-bold text-lg mt-1 mx-auto">{label}</p>
          <span onClick={onClose} className="pr-4 cursor-pointer">
            <FaTimes color="grey" />
          </span>
        </div>

        <div className="p-6 overflow-auto text-sm space-y-6">
          {Object.entries(definitionInfo).map(([key, value]) => (
            <div key={key} className="space-y-2">
              <div className="font-semibold text-base">{key.replace(/_/g, ' ')}</div>
              <div className="text-gray-800">
                {typeof value === 'string' ? (
                  <p className="leading-6">{value}</p>
                ) : (
                  <>
                    {value.description && <p className="leading-6">{value.description}</p>}
                    {value.notes && (
                      <div className="space-y-2 mt-2">
                        {value.notes.map((note, idx) => (
                          <div key={idx} className="leading-6 text-sm text-gray-700">
                            {note.content && (
                              <p>
                                <span className="font-semibold text-xs">
                                  {value.notes.length === 1
                                    ? 'Note: '
                                    : `Note ${note.label ? note.label : idx + 1}: `}
                                </span>
                                <span className="text-xs">
                                  {key === "Growth_Stage" && note.label === "1" ? (
                                    <>
                                      Investments in companies that are spun out of a larger business (ie, a Publicly Listed / Conglomerate) where the parent is transferring the assets/<i>line of business are classified as <u>Late Stage</u> even if the target company is less than 10 years</i> old. E.g. Temasek’s investment in Haldiram Snacks in March 2025 is classified as Late Stage since the Haldiram family.had merged much older existing businesses into the newly incorporated entity Haldiram Snacks Foods Pvt. Ltd
                                    </>
                                  ) : key === "Growth_Stage" && note.label === "2" ? (
                                    <>
                                      Investments in companies that are spun out of a larger business (ie, a Publicly Listed Company / Conglomerate) that are greenfield ventures - ie <i>where the parent is <u>not</u> transferring any assets/line of business</i> - are classified as Growth Stage. E.g : PB Fintech’s launch of PB Healthcare in Apr 2025 led by General Catalyst is classified as Growth Stage since no assets are being transferred by the parent company.
                                    </>
                                  ) : (
                                    note.content
                                  )}
                                </span>
                              </p>
                            )}

                            {note.listHeader && (
                              <>
                                <p className="text-sm font-semibold">{note.listHeader}</p>
                                {note.points && (
                                  <ul className="pl-4 list-disc text-sm">
                                    {note.points.map((point, index) => (
                                      <li key={index} className="ml-4">{point}</li>
                                    ))}
                                  </ul>
                                )}
                              </>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DefinitionModal;